

























import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import { User } from "@/types/user";
import { LoginRules } from "../../access.d";
@Component({})
export default class AccountLoginCmp extends Vue {
  private info: User = {
    用户名: "",
    密码: "",
  };
  private rules: LoginRules = {
    用户名: [{ required: true, message: "用户名必须填写", trigger: "blur" }],
    密码: [{ required: true, message: "密码必须填写", trigger: "blur" }],
  };
  /**
   * @description 登录
   */
  private login(): void {
    (this.$refs.loginForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = {
          account: this.info["用户名"],
          密码: this.info["密码"],
        };
        this.$store
          .dispatch("login", params)
          .then(() => {
            localStorage.setItem("center", "{}");
            this.$router.push("/main/home/shouye");
          })
          .catch((error: any) => {
            console.log(error);
            if (typeof error === "string") {
              this.$message.error(error);
            }
          });
      }
    });
  }
  /**
   * @description 初始化
   */
  private mounted(): void {
    const token = localStorage.getItem("token");
    if (token) {
      localStorage.setItem("center", "{}");
      this.$router.push("/main/home/shouye");
    }
  }
}
